export const LINKS = {
  zendeskLink: "https://zert.zendesk.com/access/jwt?jwt=",
  iubendaTermsAndConditionsLink: "https://www.iubenda.com/terms-and-conditions/82634676",
  iubendaPrivacyPolicyLink: "https://www.iubenda.com/privacy-policy/82634676",
  insuranceInfo: "https://docs.insurace.io/landing-page/documentation/cover-products/bridge-cover/li.fi",
  zendeskNewRequestLink: "https://zert.zendesk.com/hc/en-us/requests/new",
};
